import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const dialogDefaultVariants = {}
const dialogCompoundVariants = []

const dialogSlotNames = [
  [
    "overlay",
    "dialog__overlay"
  ],
  [
    "content",
    "dialog__content"
  ],
  [
    "closeIcon",
    "dialog__closeIcon"
  ],
  [
    "closeBtn",
    "dialog__closeBtn"
  ],
  [
    "header",
    "dialog__header"
  ],
  [
    "title",
    "dialog__title"
  ],
  [
    "body",
    "dialog__body"
  ],
  [
    "bodyInner",
    "dialog__bodyInner"
  ],
  [
    "footer",
    "dialog__footer"
  ],
  [
    "description",
    "dialog__description"
  ]
]
const dialogSlotFns = /* @__PURE__ */ dialogSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, dialogDefaultVariants, getSlotCompoundVariant(dialogCompoundVariants, slotName))])

const dialogFn = memo((props = {}) => {
  return Object.fromEntries(dialogSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const dialogVariantKeys = []
const getVariantProps = (variants) => ({ ...dialogDefaultVariants, ...compact(variants) })

export const dialog = /* @__PURE__ */ Object.assign(dialogFn, {
  __recipe__: false,
  __name__: 'dialog',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: dialogVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, dialogVariantKeys)
  },
  getVariantProps
})